import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const ANYONE = "__role__";

/** The active people of the organisation, for naming an approver on a workflow step. */
export function useActiveUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    let live = true;
    api.get("/users").then(({ data }) => { if (live) setUsers((data || []).filter((u) => u.is_active)); }).catch(() => {});
    return () => { live = false; };
  }, []);
  return users;
}

/** Pick one person for an approval step, or leave it on "Anyone with the role". */
export function StepApproverSelect({ value, users, onChange, testId }) {
  return (
    <Select value={value || ANYONE} onValueChange={(v) => onChange(v === ANYONE ? "" : v)}>
      <SelectTrigger className="w-48 shrink-0" aria-label="Approver" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={ANYONE}>Anyone with the role</SelectItem>
        {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.full_name} ({u.role})</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
